// components/ReduxInitializer.jsx
import { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { setCoordinator } from '../redux/slices/coordinatorSlices';

const ReduxInitializer = () => {
  const dispatch = useDispatch();

  useEffect(() => {
    const isLoggedIn = sessionStorage.getItem('isLoggedIn') === 'true';

    if (isLoggedIn) {
      const id = localStorage.getItem('cordinator_id');
      const fName = localStorage.getItem('coordinatorFName');
      const lName = localStorage.getItem('coordinatorLName');
      const email = localStorage.getItem('coordinatorEmail');
      const position = localStorage.getItem('coordinatorPosition');
      const pic = localStorage.getItem('coordinatorPic');

      if (id && fName && lName && email && position) {
        dispatch(setCoordinator({
          id, fName, lName, email, position, pic
        }));
      }
    }
  }, [dispatch]);


  return null;
};

export default ReduxInitializer;
